<template>
  <div class="add-more-bank d-flex flex-column">
    <div class="d-flex flex-row flex-md-column flex-lg-row">
      <img
        class="image mr-2"
        src="@/assets/images/common/bank-account-icon.svg"
        alt="Bank Document Icon"
        width="40"
        height="40"
      />
      <div class="drip-h3 color-noble-blue-500">
        {{ $t('bank.list.addMoreBanks.title') }}
      </div>
    </div>
    <div class="spacing-4"></div>
    <div class="content">
      <div class="drip-body font-weight-400">
        {{ $t('bank.list.addMoreBanks.subtitle') }}
      </div>
    </div>
    <div class="spacing-24"></div>
    <div class="bank-button-container">
      <action-button
        v-if="hasPermission"
        extraClass="w-100"
        :click="openAddBankAccount"
      >
        {{ $t('bank.list.addMoreBanks.button') }}
        <b-icon-plus scale="1.2" class="ml-2" />
      </action-button>
      <action-button
        v-else
        :bTitle="$t('error.unauthorizedToolTip')"
        extraClass="w-100"
      >
        {{ $t('bank.list.addMoreBanks.button') }}
        <b-icon-plus scale="1.2" class="ml-2" />
      </action-button>
    </div>
  </div>
</template>
<script>
import ActionButton from '@/components/common/ActionButton'
import { ACTIONS, ENTITIES } from '@/utils/constants'

export default {
  components: { ActionButton },
  methods: {
    openAddBankAccount() {
      this.$mpTrack('Add Bank - Navigate to add bank form')
      this.$router.push({
        name: 'addBankAccount',
        params: {}
      })
    }
  },
  computed: {
    hasPermission() {
      return this.$store.getters.hasActionPermission(
        ENTITIES.BANK,
        ACTIONS.CREATE
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.add-more-bank {
  background: $sky-blue-50;
  border-radius: 8px;
  padding: 16px;
  .content {
    flex-grow: 1;
    line-height: 33px;
    letter-spacing: 0em;
    text-align: left;
    color: $noble-blue-500;
    padding-right: 12px;
    padding-left: 4px;
    :first-child {
      margin-bottom: 2px;
    }
  }
  .bank-button-container {
    width: 100%;
  }
}
</style>
